import React from "react";

import { Box } from "@mui/material";

import type { DeploymentEvent } from "src/domains/application/hooks/useDeploymentEvents";
import type { BuildLogJob } from "src/domains/application/module/api/IApplicationApi";

import { deriveSteps } from "./job-detail-helpers";
import { ServiceDeployMatrix } from "./ServiceDeployMatrix";
import { TaskStepsList } from "./TaskStepsList";

export interface JobDetailLogsProps {
  isGroupNode: boolean;
  activeSvc: string | null;
  serviceName?: string;
  step: string;
  stepEvents: DeploymentEvent[];
  liveLogs?: Map<string, Map<string, string[]>>;
  buildLogJobs?: BuildLogJob[];
  qualityGates?: BuildLogJob[];
  templateServices?: { name: string; type: string }[];
}

export function JobDetailLogs({
  isGroupNode,
  activeSvc,
  serviceName,
  step,
  stepEvents,
  liveLogs,
  buildLogJobs,
  qualityGates,
  templateServices,
}: JobDetailLogsProps): React.ReactElement {
  return (
    <>
      {/* ── LEVEL 2: Service detail (service selected inside group) ── */}
      {isGroupNode && activeSvc && (
        <Box sx={{ flex: 1, overflow: "auto" }}>
          {/* Task steps with inline logs */}
          <TaskStepsList
            steps={deriveSteps(
              liveLogs,
              activeSvc,
              step,
              buildLogJobs,
              qualityGates,
              stepEvents,
            )}
          />
        </Box>
      )}

      {/* ── Non-group node (vcs-badge, service-build, service-deploy) ── */}
      {!isGroupNode && (
        <Box sx={{ flex: 1, overflow: "auto" }}>
          {/* ServiceDeployMatrix stays for deploy step */}
          {step === "deploy" && (
            <ServiceDeployMatrix
              events={stepEvents}
              templateServices={templateServices}
            />
          )}

          {/* Task steps with inline logs */}
          <TaskStepsList
            steps={deriveSteps(
              liveLogs,
              serviceName ?? "",
              step,
              buildLogJobs,
              qualityGates,
              stepEvents,
            )}
          />
        </Box>
      )}
    </>
  );
}
